import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsIssuesListData = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsIssuesList/ReportsIssuesList/ReportsIssuesList"
    )
);
export const ReportsIssuesList = () => {
  return (
    <Layout>
      <ReportsIssuesListData />
    </Layout>
  );
};
